// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1e6NL","info":"UpdateTermsInfo_info__3ErcT"};